// extracted by mini-css-extract-plugin
module.exports = {"inline-button":"api-error-block_inline-button__IAgj7"};